module.exports = __webpack_public_path__ + "static/right-to-bear-arms-135909366a2e0c638431fd4675514a8f.jpg";